export default __webpack_public_path__ + "static/media/Flappy Bird.8d6bd926.png";